import async from 'async';
import callAppUrl from './urlAppCaller';

const { AWS_RAW_SOURCE_IMAGE_URL, AWS_SOURCE_IMAGE_URL, IMAGEKIT_SOURCE_IMAGE_URL, GUMLET_URL_BASE_URL } = require('constants/constants');
const dayjs = require('dayjs');
const _ = require('lodash');
const { default: callUrl } = require('./urlCaller');


export function getImageKitUrl(rawUrl, height = null, width = null, formatStructure = null) {
    if (rawUrl) {
        let newImageKitUrl;
        let POST_HOST_URL;
        const AWS_RAW_URL = AWS_RAW_SOURCE_IMAGE_URL;
        const AWS_CDN_URL = AWS_SOURCE_IMAGE_URL;
        const IMAGEKIT_URL = IMAGEKIT_SOURCE_IMAGE_URL;
        const GUMLET_URL = GUMLET_URL_BASE_URL
        if (rawUrl?.startsWith(AWS_RAW_URL)) {
            newImageKitUrl = rawUrl.replace(AWS_RAW_URL, GUMLET_URL);
            POST_HOST_URL = rawUrl.split(AWS_RAW_URL)[1];
        } else if (rawUrl.startsWith(AWS_CDN_URL)) {
            newImageKitUrl = rawUrl.replace(AWS_CDN_URL, GUMLET_URL);
            POST_HOST_URL = rawUrl.split(AWS_CDN_URL)[1];
        } else if (rawUrl.startsWith(IMAGEKIT_URL)) {
            newImageKitUrl = rawUrl.replace(IMAGEKIT_URL, GUMLET_URL);
            POST_HOST_URL = rawUrl.split(AWS_CDN_URL)[1];
        } else if (rawUrl.startsWith(GUMLET_URL)) {
            newImageKitUrl = rawUrl.replace(GUMLET_URL, GUMLET_URL);
            POST_HOST_URL = rawUrl.split(GUMLET_URL)[1];
        } else {
            return rawUrl;
        }
  
        if (height === null && width === null) {
            return newImageKitUrl;
        }  else if (height !== null && width !== null) {
            // tr:w-300,h-360
            return `${GUMLET_URL}${POST_HOST_URL}?h=${height}&w=${width}`;
            // return `${IMAGEKIT_URL}/tr:vm${height}${width}${POST_HOST_URL}`;
        } else {
            return `${GUMLET_URL}${POST_HOST_URL}?w=${width}&h=${height}`;
            // return `${IMAGEKIT_URL}/tr:vm${height}${width},f-${formatStructure}${POST_HOST_URL}`;
        }
    } else {
        return null;
    }
}
export function getLabelValue (value){
    return (value && value !== '') ? value : 'venuemonk'
}

export function getProspectColor (prospect) {
    switch (prospect) {
        case 'Hot':
            return '#FF4F61';

        case 'Cold':
            return '#0057FF';

        case 'Warm':
            return '#FFA800';
    }
};

export function getBookingStatusColor (status) {
  switch (status) {
      case 'Closed - Won':
          return '#25BE50';

      case 'Closed - Lost':
          return '#FF3C3C';

      case 'Postponed':
          return '#F8B917';

      default:
        return '#25BE50'
      }
  };

  export function htmlToPlainText(html) {
    if (!html) return '';
    // Create a temporary DOM element
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    // Extract and return plain text
    return tempDiv.textContent || tempDiv.innerText || '';
  }
  
  
  export function getLabelStyle (label){
      let style = {
          borderRadius: '500px',
          padding: '0px 8px',
          color: 'white',
          fontSize: '12px',
          height: '18px',
          marginLeft: '3px'
      }
      switch (label) {
          case 'venuemonk':
              style.backgroundColor = '#491369'
              break
          case 'venue':
              style.backgroundColor = '#2A52BB'
              break
          case 'corporate':
              style.backgroundColor = '#5CA829'
              break
          case 'new':
              style.backgroundColor = '#FF4F61'
              break
          case 'social booking':
              style.backgroundColor = '#C91A02'
              break
          default:
              style.backgroundColor = '#491369'
              break
      }
      return style
  }
    
  export function splitName(name) {
        var model = {
            fname: "",
        lname: "",
    };
    var fullName = name.split(" ", 3);
    if (fullName && fullName.length > 0) {
        fullName.forEach(function (item, i) {
            if (i === 0) {
                model.fname = sentenceCase(item);
            } else {
                model.lname += sentenceCase(item) + " ";
            }
        });
    }
    model.lname = model.lname.trim();
    return model;
}

export function sentenceCase(name) {
    return name.charAt(0).toUpperCase() + name.substr(1).toLowerCase();
}

export function groupAllData(data) {
    let temp = [];
    for (let a in data) {
        temp = temp.concat(data[a]);
    }
    return temp;
}

export function removeDuplicateElements(events) {
    let newEvents = [];
    for (let i = 0; i < events.length; i++) {
        let flag = 0;
        if (events[i]) {
            for (let j = i + 1; j < events.length; j++) {
                if (events[i] === events[j]) {
                    flag = 1;
                    break;
                }
            }
            if (flag === 0) {
                newEvents.push(events[i]);
            }
        }
    }
    return newEvents;
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export function getUserInfo(user) {
    return {
        _id: user._id,
        username: user.local.name,
        email: user.local.email,
        phone: user.phone,
        access_level: user.access_level,
        user_type: user.user_type,
        venue_list: user.venue_list
    };
}

export function isValidIndianMobile(phone) {
    let newPhone = _.toString(phone);
    return newPhone && newPhone.length === 10 && (newPhone[0] === '9' || newPhone[0] === '8' || newPhone[0] === '7' || newPhone[0] === '6');
}

// sorts in descending order
export function sortByKey(array, key) {
    return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
    });
}

export function hideMobileNumber(phone) {
    if (phone) {
        let strings = _.toString(phone).split('');
        if (strings && strings.length > 4) {
            strings = _.map(strings, function (item, index) {
                if (index === 2 || index === 3 || index === 5 || index === 7 || index === 8) {
                    return 'X';
                } else {
                    return item;
                }
            });
            return strings.join('');
        } else {
            return '';
        }
    } else {
        return '';
    }
}

export function hideHalfChars(string, odd) {
    if (string && string !== '') {
        let strings = _.toString(string).split('');
        if (odd) {
            strings = _.map(strings, function (item, index) {
                if (index % 2 !== 0) {
                    return 'x';
                } else {
                    return item;
                }
            });
        } else {
            strings = _.map(strings, function (item, index) {
                if (index % 2 === 0) {
                    return 'x';
                } else {
                    return item;
                }
            });
        }
        return strings.join('');
    } else {
        return string;
    }
}

export function hideEmailAddress(email) {
    if (email) {
        let strings = _.toString(email).toLowerCase().split('.');
        let ext = strings.pop();
        strings = _.toString(strings.join('.')).split('@');
        if (strings && strings.length > 1) {
            let firstPart = hideHalfChars(strings[0], 1);
            let secondPart = hideHalfChars(strings[1], 0);
            return firstPart + "@" + secondPart + "." + ext;
        } else {
            return '';
        }
    } else {
        return '';
    }
}

export function bool(str) {
    if (str === void 0) return false;
    return str.toLowerCase() === 'true';
}

export function getPages(count, pagesize) {
    if (count > 0) {
        return Math.ceil(count / pagesize);
    } else {
        return 0;
    }
}

export function syncElasticSearch(venue, next) {
    let MANAGER_URL = process.env.REACT_APP_API_URL;
    let VENUE_URL = process.env.REACT_APP_VENUE_API_URL;
    async.parallel(
      [
        (cb) => {
          callUrl(
            `${VENUE_URL}/v1/elastic-search/venues/${venue._id}/update`,
            "get"
          ).then((res) => {
            return cb();
          });
        },
      ],
      () => {
        return next(null, "done");
      }
    );
  }


  export async function syncElasticSearchVenue(venue) {
    const VENUE_URL = process.env.REACT_APP_VENUE_API_URL;
  
    try {
      await callUrl(`${VENUE_URL}/v1/elastic-search/venues/${venue._id}/update`, "get");
      return "done";
    } catch (error) {
      throw new Error("Failed to sync ElasticSearch: " + error.message);
    }
  }
  

  export function sortByKeyReverse(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
  export function rand(min, max) {
    const random = Math.random();
    return Math.floor(random * (max - min) + min);
  }
  export function createOTP(num) {
    const length = num || 4;
    const allowsChars = "0123456789";
    let password = "";
    for (let index = 0; index < length; ++index) {
      const charIndex = rand(0, allowsChars.length - 1);
      password += allowsChars[charIndex];
    }
    return password;
  }


  export  function isFileImage(filetype) {
    return filetype && filetype.split("/")[0] === "image";
  }
  
  export function isFileVideo(filetype) {
    return filetype && filetype.split("/")[0] === "video";
  }

  export function mediaType(filetype, file) {
    let data = filetype && filetype.split("/");
    let filename = file.name.split(".");
    let ext = filename.pop();
    let result = "";
    if (data[0] === "image") {
      result = "image";
    } else if (data[0] === "video") {
      result = "video";
    } else if (data[0] === "audio") {
      result = "audio";
    } else if (
      ext === "pdf" ||
      ext === "doc" ||
      ext === "xls" ||
      ext === "xlsx" ||
      ext === "docx" ||
      ext === "txt"
    ) {
      result = "document";
    } else {
      result = "invalid";
    }
    return result;
  }
  export function fileTypeUpload(filetype, file, upload_type) {
    let data = filetype && filetype.split("/");
    let filename = file.name.split(".");
    let ext = filename.pop();
    let result = "";
    let isValid = true;
    let message = "";
    if (data[0] === upload_type) {
      result = upload_type;
    } else if (upload_type === "document") {
      if (
        ext === "pdf" ||
        ext === "doc" ||
        ext === "xls" ||
        ext === "xlsx" ||
        ext === "docx" ||
        ext === "txt"
      ) {
        result = "document";
      } else {
        result = "invalid";
      }
    } else {
      result = "invalid";
    }
  
    switch (result) {
      case "image":
        if (parseInt(file.size) > parseInt(10) * 1024 * 1024) {
          isValid = false;
          message = `File size should be less than 10MB.`;
        }
        break;
      case "video":
        if (parseInt(file.size) > parseInt(200) * 1024 * 1024) {
          isValid = false;
          message = `File size should be less than 200MB.`;
        }
        break;
      case "audio":
        if (parseInt(file.size) > parseInt(10) * 1024 * 1024) {
          isValid = false;
          message = `File size should be less than 10MB.`;
        }
        break;
      case "document":
        if (parseInt(file.size) > parseInt(20) * 1024 * 1024) {
          isValid = false;
          message = `File size should be less than 20MB.`;
        }
        break;
      default:
        isValid = false;
        message = "Invalid filetype!";
    }
    return {
      isValid,
      message,
      result,
    };
  }
  
  export function mapEventsByDate(venuecalenderList) {
    const acc = {};
    venuecalenderList.forEach(event => {
      const eventDate = dayjs(event.start_date).format("YYYY-MM-DD");
      if (!acc[eventDate]) {
        acc[eventDate] = [];
      }
      acc[eventDate].push(event);
    });
    return acc;
  }

  export function deleteCachelinks(venue, next) {
    let API_URL = process.env.REACT_APP_CUSTOMER_API_URL;
    let WEB_URL = process.env.REACT_APP_CUSTOMER_APP_URL;
    let MANAGER_URL = process.env.REACT_APP_API_URL;
    let VENUE_API_URL = process.env.REACT_APP_VENUE_API_URL;
    async.parallel(
      [
        (cb) => {
          callAppUrl(`${WEB_URL}/api/cache-invalidate`, "post", {
            pageType: "venue-overview",
            url: {
              url: `${venue.vm_id}`,
              city_slug: `${venue.city_slug}`,
            },
          }).then((res) => {
            return cb();
          });
        },
        (cb) => {
          callUrl(
            `${API_URL}/venues/${venue.city_slug}/${venue.vm_id}/v2-pages/delete-cache`,
            "get"
          ).then((res) => {
            return cb();
          });
        },
        (cb) => {
          callUrl(
            `${MANAGER_URL}/api/v3/admin-dashboard/venue/${venue._id}/primary-assets/delete-cache`,
            "get"
          ).then((res) => {
            return cb();
          });
        },
        (cb) => {
          callUrl(
            `${VENUE_API_URL}/v1/elastic-search/venues/${venue._id}/update`,
            "get"
          ).then((res) => {
            return cb();
          });
        },
        // (cb) => {
        //     callUrl(`${MANAGER_URL}/venues/venue/${venue._id}/primary-assets/delete-cache`, 'get').then(res => {
        //         return cb();
        //     });
        // }
      ],
      () => {
        return next(null, "done");
      }
    );
  }
  
  export function addcacheLinks(venue, next) {
    let API_URL = process.env.REACT_APP_CUSTOMER_API_URL;
    let MANAGER_URL = process.env.REACT_APP_API_URL;
    async.parallel(
      [
        (cb) => {
          callUrl(
            `${API_URL}/venues/${venue.city_slug}/${venue.vm_id}/v2-pages`,
            "get"
          ).then((res) => {
            return cb();
          });
        },
        (cb) => {
          callUrl(
            `${API_URL}/venues/${venue.city_slug}/${venue.vm_id}/v2-pages`,
            "get"
          ).then((res) => {
            return cb();
          });
        },
        (cb) => {
          callUrl(
            `${MANAGER_URL}/venues/venue/${venue._id}/primary-assets/add-cache`,
            "get"
          ).then((res) => {
            return cb();
          });
        },
      ],
      () => {
        return next(null, "done");
      }
    );
  }

  export default{

      splitName: splitName,
      sentenceCase: sentenceCase,
      removeDuplicateElements: removeDuplicateElements,
      groupAllData: groupAllData,
      capitalizeFirstLetter: capitalizeFirstLetter,
      randomIntFromInterval: randomIntFromInterval,
      getUserInfo: getUserInfo,
      isValidIndianMobile: isValidIndianMobile,
      sortByKey: sortByKey,
      hideMobileNumber: hideMobileNumber,
      hideEmailAddress: hideEmailAddress,
      bool: bool,
      getProspectColor: getProspectColor,
      // getLabelStyle: getLabelStyle,
      getBookingStatusColor: getBookingStatusColor,
      getPages: getPages,
      getLabelValue: getLabelValue,
      syncElasticSearch: syncElasticSearch,
      syncElasticSearchVenue:syncElasticSearchVenue,
      sortByKeyReverse: sortByKeyReverse,
      createOTP:createOTP,
      fileTypeUpload: fileTypeUpload,
      isFileImage: isFileImage,
      isFileVideo: isFileVideo,
      mediaType: mediaType,
      mapEventsByDate: mapEventsByDate,
      addcacheLinks: addcacheLinks,
      deleteCachelinks:deleteCachelinks,
      htmlToPlainText: htmlToPlainText
  };
  